// This plugin should be used when mounting all entrypoints to ensure global styles are added as a shared
// component without deduplication
import { useGlobalState } from "@/core/composables/global-state";
import { VueDataStateKey } from "@/core/composables/global-state";
// Vue plugin
export default {
    install: async (app) => {
        const globalState = useGlobalState();
        if (globalState.get(VueDataStateKey.GlobalStylesInjected))
            return;
        // Importing the component is enough to ensure that its style block is injected into the document's head.
        const GlobalSCSSPlugin = await import("@/core/components/GlobalSCSSRules.vue");
        app.component("GlobalSCSSRules", GlobalSCSSPlugin);
        globalState.set(VueDataStateKey.GlobalStylesInjected, true);
    }
};
